import type { MetaFunction } from 'react-router';

export default function Feed() {
  return (
    <div className="bg-black">
      <div className="mx-auto max-w-screen-2xl">
        <picture>
          <source
            srcSet="https://cms-cdn.thesolesupplier.co.uk/sneakers-untied-2022-desktop.jpg"
            media="(min-width: 750px)"
          />
          <source
            srcSet="https://cms-cdn.thesolesupplier.co.uk/sneakers-untied-2022-mobile.jpg"
            media="(min-width: 300px)"
          />
          <img
            src="https://cms-cdn.thesolesupplier.co.uk/sneakers-untied-2022-mobile.jpg"
            alt="Sneakers Untied 2022"
          />
        </picture>
      </div>
    </div>
  );
}

export const meta: MetaFunction = () => {
  return [
    { title: 'Sneakers Untied 2022' },
    {
      content:
        'Sneakers Untied 2022. Style and sneaker trends that defined 2022.',
      name: 'description'
    }
  ];
};
